export default {
  methods: {
    // 重叠检测函数
    checkOverlap(popupLeft, popupTop, popupWidth, popupHeight, rect) {
      const popupRight = popupLeft + popupWidth;
      const popupBottom = popupTop + popupHeight;
      
      return (
        popupRight > rect.right ||
        popupLeft < rect.left ||
        popupBottom < rect.bottom ||
        popupTop > rect.top
      );
    },
    adjustPopupPosition(overlay, pixel, width, height, rect) {
      let positioning = 'center-left';
      let horizontal = 'left';
      let vertical = 'center';
      // 检测右侧是否有空间
      if (pixel[0] + width > rect.right) {
        horizontal = 'right';
      }
      if (pixel[0] - width < rect.left) {
        horizontal = 'left';
      }
      // 检测上方是否有空间
      if (pixel[1] + height < rect.bottom) {
        vertical = 'top';
      }
      if (pixel[1] - height > rect.top) {
        vertical = 'bottom';
      }
      positioning =  vertical + '-' + horizontal;
      overlay.setPositioning(positioning);
      overlay.setOffset([horizontal === 'right' ? -18 : 50, 10]);
      // overlay.setOffset([positioning === 'center-left' ? -width : 10, 10]);
    },
  }
}
